import { AppContextState, ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";
import { lceContent, lceFetching } from "@gaming/lce";

import { AppContextActions, appContextActions, Scope } from "../actions";

// initialize with all defaults here, to ensure that the typing indicates that
// all values are always present. The server is responsible for initializing
// these and making sure these are always available to the client
const initialState: AppContextState = {
  marketInfo: {
    market: "",
    locale: "",
    language: "",
    localeWithScript: "",
  },
  requestInfo: {
    origin: "",
    anonToken: undefined,
    path: "",
  },
  isReactDomHydrating: false,
  clientBootstrapInfo: {
    initialized: lceFetching<true>(),
  },
};

const setAppContext = (
  state: AppContextState,
  action: ReturnType<typeof appContextActions.setAppContext>
) => ({
  ...action.appContext,
});

const setIsReactDomHydrating = (
  state: AppContextState,
  action: ReturnType<typeof appContextActions.setIsReactDomHydrating>
) =>
  state.isReactDomHydrating === action.isReactDomHydrating
    ? state
    : {
        ...state,
        isReactDomHydrating: action.isReactDomHydrating,
      };

const setBootstrapInitialized = (
  state: AppContextState,
  _action: ReturnType<typeof appContextActions.setBootstrapInitialized>
) => ({
  ...state,
  clientBootstrapInfo: {
    ...state.clientBootstrapInfo,
    initialized: lceContent(true),
  },
});

const appContextReducerWithoutScope = new ReducerChain<AppContextState>(initialState)
  .on(AppContextActions.SET_APP_CONTEXT, setAppContext)
  .on(AppContextActions.SET_IS_REACT_DOM_HYDRATING, setIsReactDomHydrating)
  .on(AppContextActions.SET_BOOTSTRAP_INITIALIZED, setBootstrapInitialized)
  .build();

export const appContextReducer = withScope(Scope.AppContext, appContextReducerWithoutScope);
